import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map } from "lodash";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";
import EventGroupRow from "./EventGroupRow";

import colors from "../../assets/style/colors";

const styles = {
  headerCell: {
    borderRight: "3px solid white",
    backgroundColor: colors.cardTitleBg,
    color: colors.black87,
    fontWeight: 500,
    height: "50px",
  },
};

const EventGroupsTable = (props) => {
  const {
    classes,
    data = [],
    language,
    lov,
    onSelect,
    selectedEvent,
    dialog,
    loadChildEventGroups,
    fetchingChild,
    myprofile
  } = props;

  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "300px" }}
          >
            {I18n.get("events_eventType")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "70px" }}
          >
            {I18n.get("events_active")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "200px" }}
          >
            {I18n.get("events_createdOn")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "200px" }}
          >
            {I18n.get("events_createdBy")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "150px" }}
          >
            {I18n.get("events_eventGroupId")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "200px" }}
          >
            {I18n.get("site_profileName")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "135px" }}
          >
            {I18n.get("events_profileTag")}
          </TableCellStyled>
          {!dialog && (
            <TableCellStyled
              className={classes.headerCell}
              style={{ minWidth: "135px" }}
            >
              {I18n.get("site_riskLevel")}
            </TableCellStyled>
          )}
          {!dialog && (
            <TableCellStyled
              className={classes.headerCell}
              style={{ minWidth: "135px" }}
            >
              {I18n.get("dashboard_company")}
            </TableCellStyled>
          )}
          {!dialog && (
            <TableCellStyled
              className={classes.headerCell}
              style={{ minWidth: "135px" }}
            >
              {I18n.get("common_site")}
            </TableCellStyled>
          )}
          {!dialog && (
            <TableCellStyled
              className={classes.headerCell}
              style={{ minWidth: "135px" }}
            >
              {I18n.get("common_zone")}
            </TableCellStyled>
          )}
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "135px" }}
          >
            {I18n.get("events_lieaDevice")}
          </TableCellStyled>
          <TableCellStyled
            className={classes.headerCell}
            style={{ minWidth: "170px" }}
          >
            {I18n.get("common_device")}
          </TableCellStyled>
        </TableRow>
      </TableHead>
      <TableBody>
        {map(data, (item, index) => (
          <EventGroupRow
            language={language}
            item={item}
            level={0}
            index={index}
            key={get(item, ["id"])}
            eventGroupId={get(item, ["id"])}
            lov={lov}
            onSelect={onSelect}
            selectedEvent={selectedEvent}
            isLast={true}
            dialog={dialog}
            loadChildEventGroups={loadChildEventGroups}
            fetchingChild={fetchingChild}
            myprofile={myprofile}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(EventGroupsTable);
